import { render } from "./MiniCalendar.vue?vue&type=template&id=2839d70a&scoped=true&ts=true"
import script from "./MiniCalendar.vue?vue&type=script&lang=ts"
export * from "./MiniCalendar.vue?vue&type=script&lang=ts"

import "./MiniCalendar.vue?vue&type=style&index=0&id=2839d70a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2839d70a"]])

export default __exports__